export default "__VITE_ASSET__DSbUjbp7__"